import { SearchScenarioId } from 'owa-search-next-common';
import { Suggestion } from 'owa-search-service';
import { action } from 'satcheljs';

const onSelectSuggestionViaKeyboard = action(
    'onSelectSuggestionViaKeyboard',
    (indexToSelect: number, suggestionToSelect: Suggestion, scenarioId: SearchScenarioId) => ({
        indexToSelect,
        suggestionToSelect,
        scenarioId,
    })
);

export default onSelectSuggestionViaKeyboard;
